import React from 'react';
import {FormattedMessage} from "react-intl";
import ButtonAction from "../ButtonAction";
import classnames from 'classnames';
import styles from './GlobalMessagePopup.module.scss';

export interface GlobalMessagePopupProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  message?: React.ReactNode,
  customClassname?: string,
}

const GlobalMessagePopup = ({
                              message,
                              onClick,
                              customClassname,
                              ...rest
                            }: GlobalMessagePopupProps) => {
  return (
    <div className={classnames(styles.modalContainer, customClassname)}>
      <div className={styles.message}>
        {message}
      </div>
      <div className={styles.buttonContainer}>
        <ButtonAction
          variant={'button'}
          onClick={onClick}
          label={
            <FormattedMessage
              id={'button-label-close'}
              defaultMessage={'Close'}
            />
          }
          {...rest}
        />
      </div>
    </div>
  )
};

export default GlobalMessagePopup;
